import { Component } from '@angular/core';

@Component({
  selector: 'app-no-results-found',
  templateUrl: './no-results-found.component.html',
  styleUrl: './no-results-found.component.scss',
  standalone: false,
})
export class NoResultsFoundComponent {
  NO_RESULTS_FOUND_TEXT: string = $localize`No Results Found!`;
}
